import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        getAllCallStatus: builder.mutation({
            query: (body) => ({
                url: `callStatus/getAllCallStatus`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addCallStatus: builder.mutation({
            query: (body) => ({
                url: `callStatus/addCallStatus`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getCallStatus: builder.mutation({
            query: (body) => ({
                url: `callStatus/getCallStatusById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateCallStatus: builder.mutation({
            query: (body) => ({
                url: `callStatus/updateCallStatus`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        })
    })
})

export const { useAddCallStatusMutation, useGetAllCallStatusMutation, useUpdateCallStatusMutation, useGetCallStatusMutation } = Api
